import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./Themes/fonts";
import "./index.scss";
import "./global.scss";
import "virtual:streaminal-theme.css";
import "./Themes/levels.scss";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { router } from "./routes/routes";
import ThemeProvider from "./Themes/ThemeProvider";
import { BreakpointProvider } from "react-socks";
import "./i18n";
import { LocaleProvider } from "./i18n/LocaleProvider";

const rootElement = document.getElementById("root")!;

const root = ReactDOM.createRoot(rootElement);

async function boot() {
  // DEV-only mock API (npm run dev:mock). Builds fold import.meta.env.DEV to false,
  // which drops this branch and its chunk; vite.config.ts and scripts/check-no-mock.mjs check that.
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === "1") {
    const { installMockApi } = await import("./dev/mockApi/install");
    installMockApi({ store });
  }
  root.render(
    <Provider store={store}>
      <BreakpointProvider>
        <ThemeProvider>
          <LocaleProvider>
            <RouterProvider router={router} />
          </LocaleProvider>
        </ThemeProvider>
      </BreakpointProvider>
    </Provider>
  );
}

void boot();
